import React from 'react'
import { Empty } from 'antd'
import { Routes, Route } from "react-router-dom"
import _ from 'lodash'
import intl from "react-intl-universal"
import I18n from "./i18n/I18n"
import Console from "./pages/console/index/Index"
import OrderCenter from "./pages/order/Index"
import UserCenter from './pages/user'
import global from './global'
import './App.css'


// common locale data
require('intl/locale-data/jsonp/en.js')
require('intl/locale-data/jsonp/zh.js')

// app locale data
const locales = I18n

const SUPPOER_LOCALES = [
    {
        name: 'English',
        value: 'en-US'
    },
    {
        name: '简体中文',
        value: 'zh-CN'
    }
]

console.log("CURRENT ENV:" + process.env.REACT_APP_ENV)

class App extends React.Component {

    state = { initDone: false }

    componentDidMount () {
        this.loadLocales()
    }

    loadLocales() {
        if (window.oldTimer !== null && window.oldTimer !== undefined) {
            clearTimeout(window.oldTimer);
        }

        let currentLocale = intl.determineLocale({
            cookieLocaleKey: process.env.REACT_APP_LOCALE
        })

        console.log('currentLocale:', currentLocale)
        if (currentLocale.indexOf('en') >= 0) {
            currentLocale = 'en-US'
        }
        if (currentLocale.indexOf('zh-CN') >= 0) {
            currentLocale = 'zh-CN'
        }
        global.appLang = currentLocale
        console.log('currentLocale:', currentLocale)
        // 如果没找到，则默认为英语
        if (!_.find(SUPPOER_LOCALES, { value: currentLocale })) {
            // currentLocale = 'en-US';
            currentLocale = 'zh-CN'
        }

        intl.init({
            currentLocale: currentLocale, // TODO: determine locale here
            locales,
        }).then(() => {
            // After loading CLDR locale data, start to render
            this.setState({ initDone: true })
        })
    }

    render () {
        return (
            this.state.initDone &&
            <div className="App" id={"App-" + global.appLang}>
                <Routes>
                    <Route path="/" element={<Console />} />
                    <Route path="order" element={<OrderCenter />} >
                        <Route path="list" />
                        <Route path="create" />
                        <Route path="detail" />
                        <Route path="pay" />
                        <Route path="combo" />
                    </Route>
                    <Route path="user/*" element={<UserCenter />} />

                    <Route path="*" element={<Empty description={false} />} />
                </Routes>
            </div>
        )
    }


    onSelectLocale = e => {
        let lang = e.target.value
        window.location.search = `?lang=${lang}`
    };
}

export default App
